import { useAtom } from "jotai";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { GoArrowRight } from "react-icons/go";
// @ts-ignore
import Box from "src/assets/images/box-wiz.jpg";
// @ts-ignore
import Bag from "src/assets/images/tripod.jpg";
import { useTranslation } from "react-i18next";
import { accessoriesAtom, itemsAtom } from "src/atoms/constantsCheckout";
import AccessorieStepCard from "./AccessoriesStepCard";

interface Props {
    step: number;
    setStep: Dispatch<SetStateAction<number>>;
    packages: any[];
}

const AccessoriesStep = ({ step, setStep, packages }: Props) => {
    const [items, setItems] = useAtom(itemsAtom);
    const [accessories, setAccessories] = useAtom(accessoriesAtom);
    const { t } = useTranslation();
    const continueButtonClass =
        "border bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 flex items-center space-x-4 text-white px-6 py-3 text-sm font-medium rounded-2xl shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-200";
    const camBagPackage = packages.find((pkg) => pkg.id === "7");
    const smallTripodBagPackage = packages.find((pkg) => pkg.id === "8");
    const bigTripodBagPackage = packages.find((pkg) => pkg.id === "9");

    useEffect(() => {
        setAccessories([
            {
                id: 1,
                image: Box,
                title: "Wizard Cam Travel Bag",
                price: camBagPackage ? parseFloat(camBagPackage.price) : 89,
                quantity: 0,
                price_id: "price_1TMojV7plh7U2nikEKy9y86E"
            },
            {
                id: 2,
                image: Bag,
                title: "Wizard Tripod Bag 6,1m",
                price: smallTripodBagPackage
                    ? parseFloat(smallTripodBagPackage.price)
                    : 35,
                quantity: 0,
                price_id: "price_1TMojz7plh7U2nikuhE8NoI8"
            },
            {
                id: 3,
                image: Bag,
                title: "Wizard Tripod Bag 7,4m",
                price: bigTripodBagPackage ? parseFloat(bigTripodBagPackage.price) : 29,
                quantity: 0,
                price_id: "price_1TMokP7plh7U2nikEOtL7kd7"
            },
        ]);
    }, []);

    const updateQuantity = (id: number, delta: number) => {
        setAccessories((prevItems: any) => {
            const updatedItems = prevItems.map((item: any) =>
                item.id === id
                    ? { ...item, quantity: Math.max((item.quantity || 0) + delta, 0) }
                    : item
            );
            return updatedItems;
        });
    };

    return (
        <div className="min-h-[100vh] wiz-custom-scroll-bar p-14 lg:w-3/4 ">
            <div className="max-w-6xl mx-auto px-6 py-8">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-3">
                        {t("accessoriesStep.title")}
                    </h1>{" "}
                    <p>{t("accessoriesStep.description")}</p>
                </div>
                <div className="flex flex-col justify-between h-[95%]">
                    <div className="mt-4 ">
                        <div className="flex flex-col mt-10 space-y-2">
                            {accessories.map((i: any) => (
                                <AccessorieStepCard
                                    item={i}
                                    key={i.id}
                                    updateQuantity={updateQuantity}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="flex items-center space-x-4 mt-8">
                        <button
                            onClick={() => setStep(step - 1)}
                            className="border border-[#333] px-6 py-3 text-sm font-medium rounded-full"
                        >
                            <p> {t("accessoriesStep.buttons.goBack")}</p>
                        </button>
                        <button
                            onClick={() => {
                                setStep(step + 1);
                                setItems((prev: any) => ({
                                    ...prev,

                                    accessories:
                                        accessories?.length > 0 &&
                                        accessories
                                            ?.filter((item: any) => item.quantity > 0)
                                            .map((item: any) => ({
                                                type: item.title,
                                                quantity: item.quantity,
                                                price: item.price,
                                                totalPrice: item.quantity * item.price,
                                                price_id: item.price_id
                                            })),
                                }));
                            }}
                            className={continueButtonClass}
                        >
                            <p>{t("accessoriesStep.buttons.continue")}</p>
                            <GoArrowRight className="h-5 w-5" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessoriesStep;
